import { Repository } from 'aurelia-orm';
import { Invite } from 'data/entities/entities';
import { AppRepository } from '../app-repository';

export class InviteRepository extends AppRepository {


	cancelInvite(id: number) {
		return this.call('cancelInvite', id);
	}

	findByInviteStatusId(inviteStatusId: number) {
		return this.find({inviteStatusId: inviteStatusId})
	}

	checkForDuplicateEmail(email: string) {
		return this.find(`validateEmail?email=${email}`, true);
	}

}
